<template>
    <div class="ml-5 mr-5">
         <b-loading :is-full-page="true" v-model="isFullScreenSearching" :can-cancel="true"></b-loading>
         <nav class="level">
                                <div class="level-left">
                                    
                                    <div class="level-item">
                                                <b-input placeholder="Search..."
                                                        type="search"
                                                        icon="magnify"
                                                        icon-clickable
                                                        @keyup.native.enter="searchMember" 
                                                        v-model="searchTxt"
                                                        >
                                                </b-input>
                                    </div>
                                    <div class="level-item">
                                        <b-button type="is-info" icon-left="magnify" @click="searchMember"></b-button>
                                    </div>

                                    


                                


                                </div>
            
                                <div class="level-right ">
                                </div>
                            
                            </nav>  




                    <b-table
                            :data= "isEmpty ? []  : memberResultSearch"
                            bordered
                            striped
                            hoverable

                    >   <b-table-column   label="Member ID" width="10%" centered v-slot="props">
                             
                               <b-tooltip position="is-top" multilined type="is-info is-light">
                                    <b-button type="is-info" 
                                     icon-left="pencil"
                                     @click="selectMemberID( props.row)">{{ props.row.member_id }}</b-button>

                                     
                                    <template v-slot:content>
                                      เลือก  <b> {{ props.row.name }} </b> <br/> <i> {{ props.row.member_id }}</i>.
                                    </template>
                                </b-tooltip>

                        </b-table-column>
                        <b-table-column   label="ชื่อ"   v-slot="props">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column   label="บ้านเลขที่"   v-slot="props">
                            {{ props.row.house_address }}
                        </b-table-column>

                        <b-table-column   label="ที่อยู่"   v-slot="props">
                            {{ props.row.address_txt }}  {{ props.row.tumbon_txt }} {{ props.row.ampur_txt }} {{ props.row.province_txt }} 
                        </b-table-column>

                        <b-table-column   label="โทรศัพท์"   v-slot="props">
                            {{ props.row.phone1 }}
                        </b-table-column>


 

                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="table-search"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>



                    </b-table>





    </div>
</template>


<script>

import { getBaseURLforBackEnd , getConfigAxios    } from '@/utils.js'
import axios from "axios"
import { mapState  } from "vuex";


export default {
    name : "MemberIDSelection",
    computed:{
            ...mapState({
                access_token: state => state.master_data.access_token ,
            }) ,


        },
    methods:{
        selectMemberID(payload){
           this.$emit('memberIDSelected',payload)
        },
        searchMember(){
          
          if(this.searchTxt.length<3){
              this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Search must more  <b>3 letter</b>',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'alert-circle-outline',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })

            return
          }
          this.isFullScreenSearching = true   
          const datTo = {
                "txt_search" : this.searchTxt
          }  
          axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
          axios.post(`${getBaseURLforBackEnd()}/api/searchofmemberpatho`,datTo,getConfigAxios())
               .then((res)=>{
                 this.memberResultSearch = res.data
                 this.isFullScreenSearching = false 
               })
        }
    },
    data(){
        return{
            isFullScreenSearching : false,
            searchTxt : "",
            memberResultSearch: [],
            isEmpty : false,
        }
    }
}
</script>